import { booleanAttribute, Component, input, ViewEncapsulation } from '@angular/core';

import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'bspk-list-item, button[bspk-list-item], a[bspk-list-item]',
  imports: [],
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss',
  host: {
    '[attr.data-list-item]': 'true',
    '[attr.data-active]': 'active() ? true : null',
    '[attr.aria-disabled]': 'disabled() ? true : null',
    '[attr.data-readonly]': 'readOnly() ? true : null',
  },
  encapsulation: ViewEncapsulation.None,
})
export class BspkListItem {
  readonly label = input.required<string | SafeHtml>();
  readonly active = input(false, { transform: booleanAttribute });
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly readOnly = input(false, { transform: booleanAttribute });
  readonly subText = input<string>();
}
